import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
type CheckListProps = {
  items: string[];
  columns?: 1 | 2 | 3;
  variant?: "check" | "cross";
  size?: "sm" | "base";
};
const colClass = {
  1: "",
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3"
};
export function CheckList({
  items,
  columns = 1,
  variant = "check",
  size = "sm"
}: CheckListProps) {
  const Icon = variant === "check" ? CheckIcon : XIcon;
  return <ul className={`grid gap-x-6 gap-y-2.5 ${colClass[columns]} ${size === "sm" ? "text-sm" : "text-base"}`} data-id="element-24" data-mp="33pcphzoxflnz">
      {items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-25" data-mp="2tyrl1vmknmx5">
          <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${variant === "check" ? "text-brand" : "text-neutral-400"}`} aria-hidden="true" data-id="element-26" data-mp="2tzb27a4ee7a4" />
          <span data-id="element-27" data-mp="2oxu6ru4ond0x">{item}</span>
        </li>)}
    </ul>;
}